import React from 'react';
import UniversalAddItemForm from '../shared/UniversalAddItemForm';

const DevisAddItemForm = ({ refDevis, codeEnt, onSuccess }) => {
  return (
    <UniversalAddItemForm
      refField="REF_DEV"
      refValue={refDevis}
      codeEnt={codeEnt}
      onSuccess={onSuccess}
      priceType="selling"
      enableBatch={true}
      useArticleList={false}
      submitButtonText="Add all to Devis"
    />
  );
};

export default DevisAddItemForm;
